import { useEffect, useState } from 'react';

/**
 * Shared constant for landscape detection threshold
 * Devices with height < this value (in landscape) are considered to have limited vertical space
 */
export const LANDSCAPE_HEIGHT_THRESHOLD = 600;

/**
 * Hook to detect if device is in landscape mode
 * @returns true if viewport height < width AND height < LANDSCAPE_HEIGHT_THRESHOLD
 */
export function useIsLandscape(): boolean {
  const [isLandscape, setIsLandscape] = useState(false);

  useEffect(() => {
    // Guard against SSR environments where window is undefined
    if (typeof window === 'undefined') return;

    const checkLandscape = () => {
      setIsLandscape(window.innerHeight < window.innerWidth && window.innerHeight < LANDSCAPE_HEIGHT_THRESHOLD);
    };

    checkLandscape();
    window.addEventListener('resize', checkLandscape);
    return () => window.removeEventListener('resize', checkLandscape);
  }, []);

  return isLandscape;
}
